<template>
  <div class="services-list-page">
    <ServicesHeader
      :title="data | localeField('name')"
      :breadcrumbs="breadcrumbs"
    />
    <Popup message v-if="showDatesError" @close="showDatesError = false">
      {{ $t("services.serviceModal.datesRequired") }}
    </Popup>
    <div class="services-list-page__inner">
      <Notification
        class="services-list-page__inner--notification"
        icon="warning-border--no-color"
        modify="_flex _documents"
      >
        <span
          v-html="getLocaleValue(exhibition, 'service_info')"
          class="event-popular-services__description"
        >
        </span>
      </Notification>
      <template v-for="(item, i) in categories">
        <div
          v-if="isShowInfo(item)"
          :key="`slider${i}`"
          class="container services-list-page__container"
        >
          <ServiceSliderSection :data="data.children.length ? item : data" />
        </div>
        <div
          v-if="item.services.length > 0"
          :key="`table${i}`"
          class="container services-list-page__container"
        >
          <ServiceListTableComponent
            :rows="item.services"
            action="cart"
            @showPopup="showDatesError = !showDatesError"
          />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import ServicesHeader from "@/components/Custom/ServicesHeader.vue";
import ServiceSliderSection from "@/components/Custom/ServiceSliderSection.vue";
import ServiceListTableComponent from "@/components/UI/Table/ServiceListTableComponent.vue";
import { Popup, Notification } from "@v2/shared/ui/components";
import { getLocaleValue } from "@/helpers/common";
import { mapGetters } from "vuex";

export default {
  name: "SubcategoryPage",
  components: {
    Popup,
    Notification,
    ServiceListTableComponent,
    ServiceSliderSection,
    ServicesHeader
  },
  props: {
    data: Object
  },
  data() {
    return {
      showDatesError: false
    };
  },
  methods: {
    getLocaleValue,
    isShowInfo(service) {
      if (!this.data.children?.length) {
        return true;
      }
      return service.services?.length;
    }
  },
  computed: {
    ...mapGetters("event", ["eventId", "exhibition"]),
    categories() {
      return this.data.children?.length ? this.data.children : [this.data];
    },
    breadcrumbs() {
      let links = [];
      if (this.data.parent) {
        let category = this.data.parent;
        while (category) {
          links.unshift({
            title_rus: category.name_rus,
            title_eng: category.name_eng,
            route: {
              name: "category",
              params: { id: this.$route.params.id, category_id: category.id }
            }
          });
          category = category.parent;
        }
      }
      return [
        {
          title_rus: "Выставка",
          title_eng: "Exhibition",
          route: { name: "participant", params: { id: this.$route.params.id } }
        },
        {
          title_rus: "Заказ услуг",
          title_eng: "Services ordering",
          route: { name: "categories", params: { id: this.$route.params.id } }
        },
        ...links
      ];
    }
  }
};
</script>

<style lang="scss" scoped>
.services-list-page {
  background: var(--gray);
  @media (max-width: 740px) {
    padding-bottom: 0;
  }

  & * {
    box-sizing: border-box;
  }

  &__inner {
    padding: 30px 0;
    &--notification {
      max-width: 940px;
      margin: 20px auto 25px;
    }
  }

  &__container {
    &:not(:last-child) {
      margin-bottom: 30px;
    }
  }
}
</style>
